import { Button } from '../../../button'

type OptionMenuFooterProps = {
  controls: {
    type: 'cancel' | 'confirm'
    label: string
    handler(): void
  }[]
  testID?: string
}

export const Footer = ({ controls, testID }: OptionMenuFooterProps) => {
  return (
    <div
      data-testid={testID}
      className="x-full flex items-center gap-threepulse border-border-neutral border-t-hairline bg-fill-neutral p-threepulse "
    >
      {controls.slice(0, 2).map((control, idx) => {
        const btnVariant =
          control.type === 'confirm' ? 'brand-primary' : 'neutral-tertiary'

        return (
          <Button.Root
            size="lg"
            key={String(idx)}
            variant={btnVariant}
            onClick={control.handler}
          >
            {control.label}
          </Button.Root>
        )
      })}
    </div>
  )
}
